import { hideSSNString } from "../../../../lib/script";
import DefaultUpdater from "../../../common/DefaultUpdater";


export default function PrimaryInsured({data}) {

    return <div className="flex-container-equal">
        <DefaultUpdater type={'input'} value={data.name_of_primary_insured} name={'name_of_primary_insured'} label={'Name of Primary Insured'} identifier={{type: 'case_major_med', field: 'name_of_primary_insured', type_id: data.id, folder: 'major_meds'}} />

        <DefaultUpdater type={'date'} value={data.date_of_birth} label={'Date of Birth'} identifier={{type: 'case_major_med', field: 'date_of_birth', type_id: data.id, folder: 'major_meds'}}/>

        <DefaultUpdater type={'input'} value={hideSSNString(data.ssn)} name={'ssn'} label={'SSN'} identifier={{type: 'case_major_med', field: 'ssn', type_id: data.id, folder: 'major_meds'}} extraOptions={{format: 'ssn', hideSSN: true, ssnLastFour: true}}/>
    </div>  
}